/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />

module App.Controllers
{
    export interface IContactShortController extends IBaseController
    {

    }

    export class ContactShortController extends BaseController implements IContactShortController, Interfaces.IStepController
    {
        static controllerId = 'contactShortController';

        emailregex = Constants.regexExp.email;
        postcodeRegex = Constants.regexExp.postcode;
        showFormErrors: boolean = false;
        salutation: string = null;
        initials: string
        middleName: string
        lastName: string
        telephone: string
        email: string
        postcode: string
        houseNo: string
        street: string
        city: string
        discountCode: string
        remark: string
        defaultSalutation = Constants.defaultSalutation;

        showAddresLoader = false;
        privacy: boolean
        privacyStatement: string

        nextClicked = false;

        nextStepNumber: string
        prevStepNumber: string

        stepName: string = Constants.routeKeys.contactShort;

        recurringCustomer: boolean = false;

        firstTimeDesc: string = "Wanneer uw auto eerder in onze werkplaats is geweest zijn uw gegevens bij ons bekend. Wanneer uw auto nog niet eerder in onze werkplaats is geweest hebben we aanvullende gegevens nodig.";
        personalDesc: string = "";
        discountDesc: string = "";


        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            '$stateParams',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            SnackbarFactory.factoryId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId
        ];

        constructor($rootScope: Interfaces.IAppRootScope, $scope: any, $q: ng.IQService,
            $stateParams: ng.ui.IStateParamsService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            compositionService: Interfaces.ICompositionService,
            snackbarFactory: Interfaces.ISnackbarFactory,
            ngDialog: any,
            $sce: any,
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService)
        {
            super($rootScope, $scope, $q, sessionService, navigationService, compositionService, ngDialog, $sce, validationService, accountService, snackbarFactory)

            this.nextStepNumber = (sessionService.maxStepNumber - 1).toString()
            this.prevStepNumber = (sessionService.maxStepNumber - 2).toString()
            this.privacyStatement = App.Variables.privacyStatement

            var composition = this.sessionService.composition
            if (typeof (composition) == undefined || composition == null)
                return

            if (typeof (composition.recurringCustomer) != undefined && composition.recurringCustomer != null)
                this.recurringCustomer = composition.recurringCustomer
            else if (typeof (App.Variables.recurringCustomer) != undefined && App.Variables.recurringCustomer != null)
                this.recurringCustomer = App.Variables.recurringCustomer
            else
                this.recurringCustomer = false

            if (composition.address != null)
            {
                if (composition.address.salutation != null && composition.address.salutation != '' && composition.address.salutation != '-')
                    this.salutation = composition.address.salutation
                else if (App.Variables.gender == 'm')
                    this.salutation = 'Dhr.'
                else if (App.Variables.gender == 'v')
                    this.salutation = 'Mevr.'

                if (composition.address.firstName != null && composition.address.firstName != '')
                    this.initials = composition.address.firstName
                else if (App.Variables.firstName != '')
                    this.initials = App.Variables.firstName

                if (composition.address.middleName != null && composition.address.middleName != '')
                    this.middleName = composition.address.middleName
                else if (App.Variables.middleName != '')
                    this.middleName = App.Variables.middleName

                if (composition.address.lastName != null && composition.address.lastName != '')
                    this.lastName = composition.address.lastName
                else if (App.Variables.lastName != '')
                    this.lastName = App.Variables.lastName

                if (composition.address.phoneNumber != null && composition.address.phoneNumber != '')
                    this.telephone = composition.address.phoneNumber
                else if (App.Variables.phone != '')
                    this.telephone = App.Variables.phone

                if (composition.address.email != null && composition.address.email != '')
                    this.email = composition.address.email
                else if (App.Variables.email != '')
                    this.email = App.Variables.email

                if (composition.address.postalCode != null && composition.address.postalCode != '')
                    this.postcode = composition.address.postalCode

                if (composition.address.houseNumber != null && composition.address.houseNumber != '')
                    this.houseNo = composition.address.houseNumber

                if (composition.address.street != null && composition.address.street != '')
                    this.street = composition.address.street

                if (composition.address.city != null && composition.address.city != '')
                    this.city = composition.address.city
            } else
            {
                if (App.Variables.gender == 'm')
                    this.salutation = 'Dhr.'
                else if (App.Variables.gender == 'v')
                    this.salutation = 'Mevr.'
                if (App.Variables.firstName != '')
                    this.initials = App.Variables.firstName
                if (App.Variables.middleName != '')
                    this.middleName = App.Variables.middleName
                if (App.Variables.lastName != '')
                    this.lastName = App.Variables.lastName
                if (App.Variables.phone != '')
                    this.telephone = App.Variables.phone
                if (App.Variables.email != '')
                    this.email = App.Variables.email
            }

            if (composition.selectedDiscountVoucher != null && composition.selectedDiscountVoucher != '')
                this.discountCode = composition.selectedDiscountVoucher
            else if (App.Variables.discountCode != '')
                this.discountCode = App.Variables.discountCode

            if (composition.remarks != null && composition.remarks != '')
                this.remark = composition.remarks

            this.scrollTop()
        }

        isSalutationSelected = () =>
        {
            return (this.salutation != null)
        }

        isValidPostCode = () =>
        {
            return this.postcodeRegex.test(this.postcode)
        }


        postcodeChanged = () =>
        {
            this.checkPageValidation()
            this.checkPostCodeAddress()
        }

        checkPostCodeAddress = () =>
        {
            if (this.isValidPostCode() && this.houseNo != null)
            {
                this.showAddresLoader = true

                var composition = this.sessionService.composition
                composition.houseNumber = this.houseNo
                composition.postalCode = this.postcode
                composition.recurringCustomer = this.recurringCustomer || this.isAuthenticated()
                composition.privacyCheck = false
                this.sessionService.composition = composition

                this.setCompositionValue(Constants.apiServiceStateCalls.postalCode, this.postcode, false).then(
                    (result: Classes.IComposition) =>
                    {
                        this.street = result.address.street
                        this.city = result.address.city
                    }).catch((err) =>
                    {
                        console.log('error setCompositionValue postalCode: ' + JSON.stringify(err))
                    }).finally(() =>
                    {
                        this.showAddresLoader = false
                    })
            }
        }

        isValid(isLogicCheck: boolean = false): boolean
        {
            this.showFormErrors = !isLogicCheck

            if (this.$scope.contactForm.$valid && this.privacy == true)
            {

                if (!this.nextClicked)
                {
                    this.nextClicked = true

                    var composition = this.sessionService.composition

                    if (composition.address == null)
                        composition.address = new Classes.Address()

                    composition.address.salutation = this.salutation
                    composition.address.firstName = this.initials
                    composition.address.middleName = this.middleName
                    composition.address.lastName = this.lastName
                    composition.address.phoneNumber = this.telephone
                    composition.address.email = this.email
                    composition.selectedDiscountVoucher = this.discountCode
                    composition.remarks = this.remark
                    composition.recurringCustomer = this.recurringCustomer

                    if (composition.address.street == null || composition.address.street == '') {
                        composition.address.street = this.street
                    }

                    if (composition.address.city == null || composition.address.city == '') {
                        composition.address.city = this.city
                    }

                    if (composition.address.houseNumber == null || composition.address.houseNumber == '') {
                        composition.address.houseNumber = this.houseNo
                    }

                    if (composition.address.postalCode == null || composition.address.postalCode == '') {
                        composition.address.postalCode = this.postcode
                    }

                    composition.postalCode = this.postcode
                    composition.houseNumber = this.houseNo
                    composition.privacyCheck = this.privacy
                    composition.utmParams = App.Variables.utmParams
                    this.sessionService.composition = composition
                }

                return true
            } else
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('Vul alle velden', 4000)
                }
                return false
            }
        }

        goBackToStep()
        {
            this.goToStep(Constants.routeKeys.appointment)
        }

        scrollTop = () =>
        {
            window.scrollTo(0, 0)
        }

    }

    app.controller(ContactShortController.controllerId, ContactShortController)
}